module.exports = __webpack_public_path__ + "img/17.d019d005.jpg";